"use strict";
/**
 * Simple logger function for shared package
 * For full logger, use the one from apps/api
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
const logger = (namespace) => {
    return (...args) => {
        if (typeof process !== "undefined" && process.env && process.env.DEBUG) {
            console.log(`[${namespace}]`, ...args);
        }
    };
};
exports.logger = logger;
//# sourceMappingURL=logger.js.map